export const HOST_DETAILS_PATH = '/new/hosts/:id';
